import request from '@/plugins/axios'


//批量重新生成人脸
export function generateAllPeopleFace(params) {
  return request({
    url: '/system/generateAllPeopleFace',
    method: 'get',
    params
  })
}

//批量重新生成图片标签
export function generateAllFileLabels(params) {
  return request({
    url: '/system/generateAllFileLabels',
    method: 'get',
    params
  })
}

//获取日志列表
export function listLog(params) {
  return request({
    url: '/system/listLog',
    method: 'get',
    params
  })
}


//生成所有用户网盘列表
export function generateAllUserNas(params) {
  return request({
      url: '/system/generateAllUserNas',
      method: 'get',
      params
  })
}

//重启网盘服务
export function restartNasServer(params) {
  return request({
      url: '/system/restartNasServer',
      method: 'get',
      params
  })
}

//清除所有用户权限缓存
export function flushUserPowers(params) {
  return request({
      url: '/system/flushUserPowers',
      method: 'get',
      params
  })
}

//清除所有日志
export function flushLog(params) {
  return request({
      url: '/system/flushLog',
      method: 'get',
      params
  })
}

//清除所有缓存
export function flushCache(params) {
  return request({
      url: '/system/flushCache',
      method: 'get',
      params
  })
}

//所有用户立刻下载
export function everyoneOffline(params) {
  return request({
      url: '/system/everyoneOffline',
      method: 'get',
      params
  })
}


//第三方

//创建第三方接入令牌
export function addThirdPartyAccess(data) {
  return request({
      url: '/system/addThirdPartyAccess',
      method: 'post',
      data
  })
}

//修改第三方接入令牌
export function updateThirdPartyAccess(data) {
  return request({
      url: '/system/updateThirdPartyAccess',
      method: 'post',
      data
  })
}

//获取第三方接入令牌详情
export function getThirdPartyAccess(params) {
  return request({
      url: '/system/getThirdPartyAccess',
      method: 'get',
      params
  })
}

//获取第三方接入令牌详情
export function listThirdPartyAccess(params) {
  return request({
      url: '/system/listThirdPartyAccess',
      method: 'get',
      params
  })
}


//检索数据全量同步
export function fullSearchDataSync(params) {
  return request({
      url: '/system/fullSearchDataSync',
      method: 'get',
      params
  })
}


//共享盘操作
//获取共享盘账户列表
export function listNasAccount(params) {
  return request({
      url: '/system/listNasAccount',
      method: 'get',
      params
  })
}

//重置共享盘密码
export function resetNasAccount(params) {
  return request({
      url: '/system/resetNasAccount',
      method: 'post',
      params
  })
}


//重新比对人脸记录
export function generateAllPeopleFaceDiff(params) {
  return request({
      url: '/system/generateAllPeopleFaceDiff',
      method: 'get',
      params
  })
}



//重新生成缩略图
export function generateAllThumb(params) {
  return request({
      url: '/system/generateAllThumb',
      method: 'get',
      params
  })
}